import React, { useContext, useState } from 'react'
import { RemoveLecture } from '../../../components/exl/LectureHelperFunctions';
import EditLecture from '../../../components/exl/EditLecture';
import Loading from '../../../components/Loading';
import LectureDetailsBody from './lecture-details-body/lecture-details-body';
import LectureDetailsHeader from './lecture-details-header/lecture-details-header';
import useLectureDetails from './use-lecture-details';
import { DataContext as SharedDataContext } from '../../../stores/crm-store';
import CustomModal from '../../../components/tables/shared/CustomModal';
import ExlToasts from '../../../components/crm/shared/ExlToasts';
import EditLectureAttendances from '../../../components/exl/edit-lecture-attendances/edit-lecture-attendances';
import { useTranslation } from 'react-i18next';
import { LECTURE_DETAILS_DELETE_LECTURE_WARN, DELETE } from '../../../i18n/keyConstants';

export default function LectureDetails({ id: lectureId }) {
    const [editLectureModalOpen, setEditLectureModalOpen] = useState(false);
    const [deleteLectureModalOpen, setDeleteLectureModalOpen] = useState(false);
    const [editLectureAttendancesModalOpen, setEditLectureAttendancesModalOpen] = useState(false);
    const [isRemoving, setIsRemoving] = useState();
    const { t } = useTranslation(['lectureDetails', 'shared']);
  const { dispatch: sharedDispatch } = useContext(SharedDataContext);

    const handleRemoveLecture = async (lectureId, sharedDispatch, lectureCourseId) => {
        setIsRemoving(true);
        await RemoveLecture(lectureId, sharedDispatch, lectureCourseId);
        setIsRemoving(false);
    }

  const {
    lecture,
    loading,
    lectureUser,
    refreshLectureData
  } = useLectureDetails(lectureId);
  return (
    <>
      {loading && (
        <Loading />
      )}

      {!loading && lecture && (
        <div style={{ maxWidth: "1200px", margin: "0px auto", padding: "24px" }}>
          <LectureDetailsHeader
            lecture={lecture}
            lectureUser={lectureUser}
            refreshLectureData={refreshLectureData}
            setEditLectureModalOpen={setEditLectureModalOpen}
            setDeleteLectureModalOpen={setDeleteLectureModalOpen}
            setEditLectureAttendancesModalOpen={setEditLectureAttendancesModalOpen}
          />
          <LectureDetailsBody
            lecture={lecture}
            lectureUser={lectureUser}
          />
        </div>
      )}

      {!loading && lecture && lectureUser && (
        <>
         {editLectureAttendancesModalOpen && (
            <EditLectureAttendances 
              lecture={lecture}
              open={editLectureAttendancesModalOpen}
              onClose={() => setEditLectureAttendancesModalOpen(false)}
              refreshLectureData={refreshLectureData}
              />
          )}

          {editLectureModalOpen && (
            <EditLecture
              open={editLectureModalOpen}
              onClose={() => setEditLectureModalOpen(false)}
              updateLecture={lecture}
              submitHandler={refreshLectureData}
              permissionRole={(
                lectureUser.teacherPermission &&
                !lectureUser.editPermission) ? "teacher"
                : undefined
              }
            />
          )}
          <CustomModal
            show={deleteLectureModalOpen}
            onHide={() => { setDeleteLectureModalOpen(false) }}
            modalText={t(LECTURE_DETAILS_DELETE_LECTURE_WARN) }
            buttonText={t(DELETE, {ns: 'shared'}) }
            handleModal={() => { handleRemoveLecture(lecture.id, sharedDispatch, lecture.course.id) }}
            modalVariant='danger'
            isSaving={isRemoving }
          />
          <ExlToasts />
        </>
      )}
    </>
  )
}
